import { DeathTimer } from '../../gameClient/webgl/deathTimer';

export class DontKillMePlsHandler {
    public handle(): void {
        DeathTimer.restartTimer();
    }
}
